import { Tooltip } from "@design-system/Tooltip/Tooltip";
import { RuleGroupType } from "@common/types/transactionRule";
import { Tabs } from "@design-system/Tabs/Tabs";

export const RulesPageNav = () => (
    <Tabs.List>
        <Tooltip content="Apply custom changes to transactions on sync">
            <Tabs.Tab value={RuleGroupType.TRANSACTION}>Transactions</Tabs.Tab>
        </Tooltip>
        <Tooltip content="Map transactions to the Chart of Accounts">
            <Tabs.Tab value={RuleGroupType.ACCOUNTING}>Accounting</Tabs.Tab>
        </Tooltip>
        <Tooltip content="Apply custom rules to transfers">
            <Tabs.Tab value={RuleGroupType.TRANSFER}>Transfers</Tabs.Tab>
        </Tooltip>
        <Tooltip content="Automatically split transactions">
            <Tabs.Tab value={RuleGroupType.SPLIT}>Split</Tabs.Tab>
        </Tooltip>
    </Tabs.List>
);
